import { useTranslation } from 'react-i18next';
import { Loader2 } from 'lucide-react';

interface TableLoadingProps {
  /** Inline mode (inside table row) */
  inline?: boolean;
  /** Number of skeleton rows to show */
  rows?: number;
  /** Number of columns for skeleton */
  columns?: number;
}

export function TableLoading({ inline = false, rows = 5, columns = 5 }: TableLoadingProps) {
  const { t } = useTranslation();
  if (inline) {
    return (
      <div className="flex items-center justify-center py-8">
        <Loader2 className="w-6 h-6 text-accent-600 animate-spin" />
        <span className="ml-2 text-sm text-text-muted">{t('ui.configurableTable.loading')}</span>
      </div>
    );
  }

  return (
    <div className="bg-bg-elevated rounded-lg shadow overflow-hidden animate-pulse">
      {/* Header skeleton — 44px, tło surface/subtle, padding poziomy 16px (parytet z tabelą). */}
      <div className="bg-[rgb(var(--color-surface-subtle))] border-b border-border-secondary">
        <div className="flex">
          {Array.from({ length: columns }).map((_, i) => (
            <div key={i} className="flex-1 h-11 px-4 flex items-center">
              <div className="h-3 bg-bg-tertiary rounded w-3/4" />
            </div>
          ))}
        </div>
      </div>

      {/* Body skeleton — wiersze 56px, dzielnik border/divider. */}
      <div className="divide-y divide-[rgb(var(--color-border-divider))]">
        {Array.from({ length: rows }).map((_, rowIndex) => (
          <div key={rowIndex} className="flex">
            {Array.from({ length: columns }).map((_, colIndex) => (
              <div key={colIndex} className="flex-1 h-14 px-4 flex items-center">
                <div
                  className="h-4 bg-bg-tertiary rounded"
                  style={{ width: `${50 + Math.random() * 40}%` }}
                />
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
